import { render, staticRenderFns } from "./SummaryRow.vue?vue&type=template&id=c0ebf712&scoped=true&"
import script from "./SummaryRow.vue?vue&type=script&lang=js&"
export * from "./SummaryRow.vue?vue&type=script&lang=js&"
import style0 from "./SummaryRow.vue?vue&type=style&index=0&id=c0ebf712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ebf712",
  null
  
)

export default component.exports